import { createFileRoute } from '@tanstack/react-router';

import { DealerProfilePage } from '@/features/operator/profile/dealer-profile-page';
import { validateProfileSearch } from '@/features/operator/profile/profile-search';

/**
 * Повний профіль дилера. `dealers_` — поза каркасом списку Dealers: профіль
 * займає всю сторінку, а не відкривається в його панелі.
 */
export const Route = createFileRoute('/_operator/dealers_/$dealerId')({
	validateSearch: validateProfileSearch,
	component: DealerProfilePage,
});
